/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsListRegistry } from "../../funcs/llmModelsListRegistry.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$llmModelsListRegistry: ToolDefinition = {
  name: "llm-models-list-registry",
  description: `List the organization's active model registry

Single management view of every active name with source-qualified definition, health, price, and activation audit details.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await llmModelsListRegistry(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
